<template>
    <div>
        <h1>Show {{ item && item['@id'] }}</h1>

        <div v-if="loading" class="alert alert-info" role="status">Loading...</div>
        <div v-if="error" class="alert alert-danger" role="alert"><span class="oi oi-warning" aria-hidden="true"></span>
            {{ error }}
        </div>
        <div v-if="deleteError" class="alert alert-danger" role="alert"><span class="oi oi-warning"
                                                                              aria-hidden="true"></span> {{ deleteError
            }}
        </div>

        <div v-if="item" class="table-responsive">
            <table class="table table-striped table-hover">

                <tbody>
                <tr>
                    <td>eHotelier Text-Id</td>
                    <td>{{ item['ehotelierTextId'] }}</td>
                </tr>
                <tr>
                    <td>import data from eHotelier?</td>
                    <td>{{ item['doImport'] }}</td>
                </tr>
                <tr>

                    <td colspan="2">
                        <ul class="nav nav-tabs" id="translationsTab" role="tablist">
                            <li v-for="(value, key, index) in languages" class="nav-item">
                                <a class="nav-link" v-bind:class="{ active: index===0, show: index===0 }"
                                   :id="'translation-tab-' + key" data-toggle="tab"
                                   :href="'#translation-tab-content-' + key" role="tab" :aria-controls="index"
                                   aria-selected="false">{{
                                    value }}</a>
                            </li>
                        </ul>
                        <div class="tab-content" id="translationsTabContent">

                            <div v-for="(value, key) in item.translations" class="tab-pane fade"
                                 v-bind:class="{ active: key===0, show: key===0 }" :id="'translation-tab-content-' + key"
                                 role="tabpanel" :aria-labelledby="'translation-tab-' + key">
                                <table class="table table-striped table-hover">
                                    <tbody>
                                    <tr>
                                        <td>Legal Name</td>
                                        <td>{{ item.translations[key]['legalName'] }}</td>
                                    </tr>
                                    <tr>
                                        <td>Chamber Of Commerce</td>
                                        <td>{{ item.translations[key]['chamberOfCommerce'] }}</td>
                                    </tr>
                                    <tr>
                                        <td>Commercial Register</td>
                                        <td>{{ item.translations[key]['commercialRegister'] }}</td>
                                    </tr>
                                    <tr>
                                        <td>Association Register</td>
                                        <td>{{ item.translations[key]['associationRegister'] }}</td>
                                    </tr>
                                    <tr>
                                        <td>Partnership Register</td>
                                        <td>{{ item.translations[key]['partnershipRegister'] }}</td>
                                    </tr>
                                    <tr>
                                        <td>Cooperatives Register</td>
                                        <td>{{ item.translations[key]['cooperativesRegister'] }}</td>
                                    </tr>
                                    <tr>
                                        <td>Commercial Court</td>
                                        <td>{{ item.translations[key]['commercialCourt'] }}</td>
                                    </tr>
                                    <tr>
                                        <td>Regulatory Authority</td>
                                        <td>{{ item.translations[key]['regulatoryAuthority'] }}</td>
                                    </tr>
                                    <tr>
                                        <td>Description</td>
                                        <td>{{ item.translations[key]['description'] }}</td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </td>
                </tr>

                <tr>
                    <td>Email</td>
                    <td>{{ item['email'] }}</td>
                </tr>
                <tr>
                    <td>PEC-Email</td>
                    <td>{{ item['emailPec'] }}</td>
                </tr>
                <tr>
                    <td>Telephone</td>
                    <td>{{ item['telephone'] }}</td>
                </tr>
                <tr>
                    <td>Fax Number</td>
                    <td>{{ item['faxNumber'] }}</td>
                </tr>
                <tr>
                    <td>Logo</td>
                    <td>{{ item['logo'] }}</td>
                </tr>
                <tr>
                    <td>REA</td>
                    <td>{{ item['rea'] }}</td>
                </tr>
                <tr>
                    <td>UID</td>
                    <td>{{ item['uid'] }}</td>
                </tr>
                <tr>
                    <td>Chamber Of Commerce Number</td>
                    <td>{{ item['chamberOfCommerceNumber'] }}</td>
                </tr>
                <tr>
                    <td>Commercial Register Number</td>
                    <td>{{ item['commercialRegisterNumber'] }}</td>
                </tr>
                <tr>
                    <td>Association Register Number</td>
                    <td>{{ item['associationRegisterNumber'] }}</td>
                </tr>
                <tr>
                    <td>Partnerships Register Number</td>
                    <td>{{ item['partnershipsRegisterNumber'] }}</td>
                </tr>
                <tr>
                    <td>Cooperatives Register Number</td>
                    <td>{{ item['cooperativesRegisterNumber'] }}</td>
                </tr>
                <tr>
                    <td>Commercial Court Number</td>
                    <td>{{ item['commercialCourtNumber'] }}</td>
                </tr>
                <tr>
                    <td>Legal Representative</td>
                    <td>{{ item['legalRepresentative'] }}</td>
                </tr>
                <tr>
                    <td>Administrator</td>
                    <td>{{ item['administrator'] }}</td>
                </tr>
                <tr>
                    <td>Management</td>
                    <td>{{ item['management'] }}</td>
                </tr>
                <tr>
                  <td>Tax ID</td>
                  <td>{{ item['taxID'] }}</td>
                </tr>
                <tr>
                  <td>CIR - Codice Identificativo Regionale</td>
                  <td>{{ item['cir'] }}</td>
                </tr>
                <tr>
                  <td>CIN - Codice Identificativo Nazionale</td>
                  <td>{{ item['cin'] }}</td>
                </tr>
                <tr>
                    <td>Share Holder</td>
                    <td>{{ item['shareHolder'] }}</td>
                </tr>
                <tr>
                    <td>Share Capital</td>
                    <td>{{ item['shareCapital'] }}</td>
                </tr>
                <tr>
                    <td>Editorial</td>
                    <td>{{ item['editorial'] }}</td>
                </tr>
                <tr>
                    <td>Data Protection Supervisor Title</td>
                    <td>{{ item['dataProtectionSupervisorTitle'] }}</td>
                </tr>
                <tr>
                    <td>Data Protection Supervisor</td>
                    <td>{{ item['dataProtectionSupervisor'] }}</td>
                </tr>
                <tr>
                    <td>Address Country</td>
                    <td>{{ item['addressCountry'] }}</td>
                </tr>
                <tr>
                    <td>Address Locality</td>
                    <td>{{ item['addressLocality'] }}</td>
                </tr>
                <tr>
                    <td>Address Region</td>
                    <td>{{ item['addressRegion'] }}</td>
                </tr>
                <tr>
                    <td>Post Office Box Number</td>
                    <td>{{ item['postOfficeBoxNumber'] }}</td>
                </tr>
                <tr>
                    <td>Postal Code</td>
                    <td>{{ item['postalCode'] }}</td>
                </tr>
                <tr>
                    <td>Street Address</td>
                    <td>{{ item['streetAddress'] }}</td>
                </tr>
                <tr>
                    <td>Created At</td>
                    <td>{{ item['createdAt'] }}</td>
                </tr>
                <tr>
                    <td>Updated At</td>
                    <td>{{ item['updatedAt'] }}</td>
                </tr>
                </tbody>
            </table>
        </div>


        <footer class="footer fixed-bottom bn-footer">

            &nbsp;

            <div style="float:right">
                <router-link v-if="item" :to="{ name: 'OrganizationList' }" class="btn btn-primary btn-sm">Back to
                    list
                </router-link>
                <button @click="deleteItem(item)" class="btn btn-danger btn-sm">Delete</button>
            </div>
        </footer>


    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {API_LANGUAGES} from '../../config/languages';

    export default {
        computed: mapGetters({
            deleteError: 'organization/del/error',
            error: 'organization/show/error',
            loading: 'organization/show/loading',
            item: 'organization/show/item',
        }),
        methods: {
            deleteItem(item) {
                if (window.confirm('Are you sure you want to delete this item?'))
                    this.$store.dispatch('organization/del/delete', item).then(response => this.$router.push({name: 'OrganizationList'}));
            }
        },
        created() {
            this.$store.dispatch('organization/show/retrieve', decodeURIComponent(this.$route.params.id));
        },
        beforeDestroy() {
            this.$store.dispatch('organization/show/reset');
        },
        data: function () {
            return {
                languages: API_LANGUAGES
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/organization/Show.vue